var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 43,
    viewBox: "0 0 50 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.796952 19.2232C0.728202 19.3633 0.759342 19.5316 0.873764 19.6384L24.6493 42.2601C24.7896 42.3937 25.0111 42.3937 25.1514 42.2601L48.927 19.6398C49.0414 19.5331 49.0725 19.3647 49.0038 19.2246L40.2005 0.863934C40.1425 0.737992 40.0157 0.657381 39.8762 0.657757H9.92738C9.78723 0.656005 9.65909 0.736199 9.60024 0.862516L0.796952 19.2232V19.2232Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8705 21.2543C15.8239 20.9883 11.3105 19.9357 11.3105 18.6755C11.3105 17.4152 15.8239 16.364 21.8705 16.0938V20.206C22.266 20.2344 23.3982 20.3013 24.9628 20.3013C26.8404 20.3013 27.7806 20.223 27.9499 20.2074V16.0966C33.9838 16.3654 38.4871 17.418 38.4871 18.6755C38.4871 19.9329 33.9909 20.9869 27.9556 21.2543C27.7849 21.2671 26.903 21.3197 24.9358 21.3197C23.3712 21.3197 22.2603 21.2728 21.8705 21.2543V21.2543ZM36.376 11.9914V6.37988H13.4497V11.9914H21.8689V15.6698C15.0256 15.9841 9.87939 17.3397 9.87939 18.9641C9.87939 20.5885 15.0256 21.9427 21.8689 22.2584V34.0503H27.9539V22.2542C34.7815 21.9398 39.9192 20.5856 39.9192 18.9627C39.9192 17.3397 34.7872 15.987 27.9554 15.6712V11.9914H36.376V11.9914Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallUsdt);
export default __webpack_public_path__ + "static/media/small_usdt.19fcb577b42acf54ef709d7341e84c01.svg";
export { ForwardRef as ReactComponent };